'use client';

import {
  Flex,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalOverlay,
  useTheme
} from '@chakra-ui/react';

import { VideoPlayer } from '../VideoPlayer';

interface VideoModalProps {
  isOpen: boolean;
  onClose: () => void;
  url: string;
}

const VideoModal = ({ isOpen, onClose, url }: VideoModalProps) => {
  const {
    colors: {
      palette: {
        shop: {
          products: {
            listStep: {
              listContainer: { container: styles }
            }
          }
        }
      }
    }
  } = useTheme();

  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered>
      <ModalOverlay bg='blackAlpha.600' />
      <ModalContent
        borderRadius='12px'
        margin='15px'
        maxW={{ base: '90%', md: '80%', lg: '80%' }}
      >
        <ModalCloseButton
          bg={styles.emptyImageBg}
          color={styles.closeButtonColor}
          _hover={{ bg: styles.closeButtonBackground }}
          zIndex={10}
        />
        <ModalBody p={0} h='80vh' overflow='hidden' borderRadius='12px'>
          <Flex w='full' h='80vh' flex={1} bg={styles.imageBackground}>
            <VideoPlayer url={url} />
          </Flex>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default VideoModal;
